import SettingsIcon from '@mui/icons-material/Settings';
import ConfigurationManagement from './ConfigurationManagement';


export default {
    icon: SettingsIcon,
    recordRepresentation: 'reference',
    list: ConfigurationManagement
};
